import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReportResponse } from '../models/models'

export class GetOrderReportUsersApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReportsAppUsers',
      requesterInfo,
    })
  }

  public async getReport(): Promise<any> {
    return await this.getAsync<any>()
  }
}
